import {useEffect, useState} from 'react';
import { Snackbar, Alert, Input, Box} from '@mui/material';
import { useApp } from './AppContext';

export interface AppSnackBarInput{
  // You can add props here if you want to control the snackbar from outside
  message: string;
  severity?: 'success' | 'error' | 'warning' | 'info';
}

const AppSnackBar = () => {
  const [open, setOpen] = useState(true);
  const { snackbarInput } = useApp();

  useEffect(() => {
    if (!snackbarInput.message) {
      setOpen(false);
      return;
    }

    setOpen(true);
  }, [snackbarInput]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={1500}
      onClose={() => setOpen(false)}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      sx={{
        '& .MuiSnackbarContent-root': {
          minWidth: 'auto',
        },
      }}
    >
      <Alert 
        onClose={() => setOpen(false)}
        severity={snackbarInput.severity || 'info'}
        sx={{ 
          width: '100%',
          boxShadow: 3,
        }}
      >
        {snackbarInput.message}
      </Alert>
    </Snackbar>
   
  );
};

export default AppSnackBar;
